module.exports = __webpack_public_path__ + "img/4.e3b6e5dd.png";